/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Reason for refusing a freelancer's RQTH declaration.
 * @export
 */
export const RqthRefusalReason = {
    Other: 'OTHER',
    IncorrectDocument: 'INCORRECT_DOCUMENT',
    DocumentNotReadable: 'DOCUMENT_NOT_READABLE',
    Expired: 'EXPIRED'
} as const;
export type RqthRefusalReason = typeof RqthRefusalReason[keyof typeof RqthRefusalReason];


export function instanceOfRqthRefusalReason(value: any): boolean {
    for (const key in RqthRefusalReason) {
        if (Object.prototype.hasOwnProperty.call(RqthRefusalReason, key)) {
            // @ts-ignore
            if (RqthRefusalReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RqthRefusalReasonFromJSON(json: any): RqthRefusalReason {
    return RqthRefusalReasonFromJSONTyped(json, false);
}

export function RqthRefusalReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): RqthRefusalReason {
    return json as RqthRefusalReason;
}

export function RqthRefusalReasonToJSON(value?: RqthRefusalReason | null): any {
    return value as any;
}

